import { useLocalizedHref } from "@libraries/web-framework";
import { useIntl } from "react-intl";

import BannerAlert from "@/components/wpl/banner-alert/src";
import { cssReset } from "@/libraries/wpl/foundations/src";
import GlobalFooter from "@/patterns/global-footer/src/index";

import CTASectionPaidLpJswTracker from "./sections/cta";
import HeroSectionPaidLpJswTracker from "./sections/hero";
import SideBySideAlternatingImageAndTextSectionPaidLpJswTracker from "./sections/sideBySideAlternatingImageAndTextSection";
import SocialProofPaidLpJswTracker from "./sections/social-proof";
import JiraSoftwareNavPaidLpJswTracker from "./sections/software-jira-navbar";
import Tabs from "./sections/tabs/index";

export const JiraSoftwarePageTemplatePaidLpJswTracker = () => {
    const intl = useIntl();

    const bannerMessages = {
        identifier:
            "jira-software.paidLpJswTracker.banner-alert.atlassian-intelligence",
        text: intl.formatMessage({
            id: "jira-software.paidLpJswTracker.banner-alert.text",
            defaultMessage:
                "Get early access to Atlassian Intelligence, your new virtual teammate that deeply understands how teams collaborate to accelerate work."
        }),
        linkText: intl.formatMessage({
            id: "jira-software.paidLpJswTracker.banner-alert.link-text",
            defaultMessage: "Learn more"
        }),
        linkUrl: useLocalizedHref("/software/artificial-intelligence")
    };

    return (
        <div css={cssReset}>
            <JiraSoftwareNavPaidLpJswTracker />
            <BannerAlert
                identifier={bannerMessages.identifier}
                text={bannerMessages.text}
                linkUrl={bannerMessages.linkUrl}
                linkText={bannerMessages.linkText}
            />
            <HeroSectionPaidLpJswTracker />
            <Tabs />
            <SideBySideAlternatingImageAndTextSectionPaidLpJswTracker />
            <CTASectionPaidLpJswTracker />
            <SocialProofPaidLpJswTracker />
            <GlobalFooter />
        </div>
    );
};
